import React, { Component } from 'react';
import { Modal, InputNumber, Spin, message } from 'antd';
import Text from '../../basicElement/Text';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';

class AdjustRoleFte extends Component {
    state = {
        data: {},
        loading: false,
        visible: false,
    }

    show = (data) => {
        this.setState({
            data,
            visible: true
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleChange = (value, key) => {
        const { data } = this.state;
        data[key] = value;
        this.setState({ data });
    }

    getContent = () => {
        const { data } = this.state;
        const { roleCode, userCompellation, employeeCode, fteValue } = data;
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left"><Text asterisk={false} colon={true}>{roleCode}</Text></div>
                    <div className="item-right">{userCompellation}({employeeCode})</div>
                </li>
                <li className="modal-item">
                    <div className="item-left"><Text asterisk={true} colon={true}>计划FTE</Text></div>
                    <div className="item-right">
                        <InputNumber
                            step={0.1}
                            precision={2}
                            placeholder="请输入"
                            value={fteValue}
                            style={{ width: 120 }}
                            onChange={value => this.handleChange(value, 'fteValue')}
                        />
                    </div>
                </li>
            </ul>
        );
    }

    confirm = () => {
        const { data } = this.state;
        const { date, fteValue, investigationId } = data;
        if (!fteValue && fteValue !== 0) {
            return message.warning('计划FTE不能为空');
        }
        this.setState({ loading: true });
        const options = {
            url: API_URL.plan.changePmAndPaRequirementFte,
            data: {
                ...data,
                investigationId,
                date: date ? date.slice(0, 10) : ''
            },
            dataType: 'json',
            doneResult: (res) => {
                message.success(res.success);
                this.hide();
                this.setState({ loading: false }, () => {
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    render() {
        const { visible, loading } = this.state;
        return (
            <Modal
                title='FTE调整'
                visible={visible}
                onCancel={this.hide}
                onOk={this.confirm}
                confirmLoading={loading}
                maskClosable={false}
                width="400px"
            >
                <Spin spinning={loading}>
                    <div className="modal-content form-list fortyPercentage" style={{padding: 0}}>
                        {this.getContent()}
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default AdjustRoleFte;


// WEBPACK FOOTER //
// ./src/components/sumTotal/projectPercent/AdjustRoleFte.js